module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view'), _vm._v(" "), _c('div', {
    staticClass: "pharmacy-edit-type"
  }, [(_vm.$store.state.user.role == 'HM') ? _c('router-link', {
    staticClass: "pharmacy-edit-type__link",
    attrs: {
      "activeClass": "pharmacy-edit-type__link--current",
      "exact": "",
      "to": ("/pharmacies/" + (_vm.$route.params.id) + "/edit/"),
      "title": ""
    }
  }, [_vm._v("Редактирование")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "pharmacy-edit-type__link",
    attrs: {
      "activeClass": "pharmacy-edit-type__link--current",
      "to": ("/pharmacies/" + (_vm.$route.params.id) + "/info/"),
      "title": ""
    }
  }, [_vm._v("Информация")]), _vm._v(" "), (_vm.$route.path == ("/pharmacies/" + (_vm.$route.params.id) + "/info/")) ? _c('a', {
    staticClass: "pharmacy-edit-type__link",
    staticStyle: {
      "margin-left": "75px"
    },
    attrs: {
      "title": "",
      "href": ("/api/reports/productspharmacy?pharmacyId=" + (_vm.$route.params.id) + "&userId=" + (_vm.$store.state.user.id))
    }
  }, [_vm._v("Отчет по выкладке")]) : _vm._e(), _vm._v(" "), (_vm.$route.path == ("/pharmacies/" + (_vm.$route.params.id) + "/info/") && _vm.$store.state.user.role == 'PM') ? _c('a', {
    staticClass: "pharmacy-edit-type__link",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "title": "",
      "href": ("/api/reports/productspharmacy?diff=Y&pharmacyId=" + (_vm.$route.params.id) + "&userId=" + (_vm.$parent.$parent.user.id))
    }
  }, [_vm._v("Отчет по различиям")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13c77c2c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pharmacy/PharmacyPage.vue
// module id = 231
// module chunks = 1